<template>
  <div class="search-main">
    <el-select
        ref="headerSearchSelect"
        v-model="search"
        filterable
        remote
        :remote-method="querySearch"
        default-first-option
        placeholder="Search"
        @change="change"
        style="width: 180px;"
    >
      <template #prefix>
        <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
      </template>
      <el-option v-for="item in options" :key="item.item.url" :value="item.item.url" :label="item.item.label" />
    </el-select>
  </div>
</template>

<script>
import Fuse from 'fuse.js'
export default {
  name: "search",
  data() {
    return {
      search: '',
      options: [],
      searchPool: [],
      show: false,
      fuse: undefined
    }
  },
  computed: {
    menuList() {
      return JSON.parse(localStorage.getItem('menuList'))
    }
  },
  methods: {
    querySearch(query) {
      if (query !== '') {
        this.options = this.fuse.search(query)
        // console.log(this.options)
      } else {
        this.options = []
      }
    },
    change(val) {
      this.$router.push(val)
      this.search = ''
      this.options = []
    },

    getPool() {
      for (let i=0; i<this.menuList.length; i++) {
        if (this.menuList[i].children && this.menuList[i].children.length > 0) {
          for (let j=0; j<this.menuList[i].children.length; j++){
            let obj1 = {}
            obj1.url = this.menuList[i].children[j].url
            obj1.label = this.menuList[i].name + ' > ' + this.menuList[i].children[j].name
            this.searchPool.push(obj1)
          }
        } else {
          let obj2 = {}
          obj2.url = this.menuList[i].url
          obj2.label = this.menuList[i].name
          this.searchPool.push(obj2)
        }
      }
      // console.log(this.searchPool)
      this.fuse = new Fuse(this.searchPool, {
        shouldSort: true,
        threshold: 0.4,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [{
          name: 'label',
          weight: 0.7
        }, {
          name: 'url',
          weight: 0.3
        }]
      })
    },

  },
  mounted() {
    this.getPool()
  }
}
</script>

<style lang="scss" scoped>
//.search-main {
//  margin: 0 16px;
//}

</style>
